import React, { useState } from "react";
import {
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

export const PanelActions = ({ panel, onExport }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [exporting, setExporting] = useState(false);

  if (!panel?.exportable) {
    return null;
  }

  const handleExport = async () => {
    setAnchorEl(null);
    setExporting(true);

    try {
      await onExport(panel.panel_id);
    } finally {
      setExporting(false);
    }
  };

  return (
    <>
      <Tooltip title="Opciones">
        <span>
          <IconButton
            size="small"
            disabled={exporting}
            onClick={(event) => setAnchorEl(event.currentTarget)}
            sx={{
              bgcolor: "background.paper",
              boxShadow: 1,
              "&:hover": { bgcolor: "background.paper" },
            }}
          >
            {exporting ? (
              <CircularProgress size={16} />
            ) : (
              <MoreVertIcon fontSize="small" />
            )}
          </IconButton>
        </span>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        <MenuItem onClick={handleExport}>
          <ListItemIcon>
            <FileDownloadOutlinedIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Exportar Excel</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};
